import React from 'react';
import Header from '@src/components/Base/Header/StandardHeader';
import DefaultHead from '@src/components/Base/Head/DefaultHead';
import MobileSearchbar from '@src/components/Base/Header/MobileSearchbar';
import WindowDimension from '@src/components/Base/WindowDimension';
import Footer from '@src/components/Base/Footer/Footer';
import Meta from '@src/components/Base/Head/Meta';
import styles from './UpdateContent.module.css';
import { Container, Row, Col } from 'reactstrap';
import axios from 'axios';
import { createHeaderFromContext } from '@src/lib/ssr/createHeaderFromContext';

export default function UpdateContentPage({ metaData, content }) {
  return (
    <>
      <DefaultHead />
      <Meta
        title={`리걸엔진 | ${metaData?.title}`}
        description={metaData?.description}
        url={`update/${metaData?.id}`}
      />
      <Header imgSrc='../logo.svg' />
      <MobileSearchbar />
      <Container className={styles.updateContent}>
        <Row>
          <Col>
            <div className={styles.updateContentsHeader}>
              <h1 className={styles.updateContentsHeaderTitle}>
                <span className={styles.updateContentsTitle}>{metaData?.title}</span>
              </h1>
              <p className={styles.updateContentsDescription}>{metaData?.description}</p>
              <div className={styles.updateContentsMetaData}>
                <span className={styles.updateContentsAuthor}>작성자: {metaData?.author}</span>
                <span className={styles.updateContentsDate}>{String(metaData?.timestamp).split('T')[0]}</span>
              </div>
            </div>
            <div id={styles.updateSpace} />
            <div className={styles.caseContent}>
              <div>
                {content.map((line) => {
                  return line.section_idx === 0 ? (
                    <div key={line.idx}>
                      <h5 className={styles.updateContentParagraphTitle}>{line.section}</h5>
                      <div
                        className={styles.updateParagraphBody}
                        dangerouslySetInnerHTML={{ __html: line.paragraph }}
                      />
                    </div>
                  ) : (
                    <div className={styles.updateParagraphBody} dangerouslySetInnerHTML={{ __html: line.paragraph }} />
                  );
                })}
              </div>
            </div>
          </Col>
        </Row>
      </Container>
      <Footer />
    </>
  );
}

export const getServerSideProps = async (context) => {
  const { UpdateId } = context.query;

  // createHeader
  const header = await createHeaderFromContext(context);

  const [updateResult, updateContentsResult] = await Promise.all([
    axios.get(process.env.NEXT_PUBLIC_REST_API_URI_LEGACY + '/updates', { headers: header }),
    axios.get(process.env.NEXT_PUBLIC_REST_API_URI_LEGACY + '/updates/' + UpdateId, { headers: header }),
  ]);

  return {
    props: {
      content: updateContentsResult.data,
      metaData: updateResult.data.filter(({ id }) => id === Number(UpdateId))[0],
    },
  };
};
